module.exports = __webpack_public_path__ + "static/media/07.e8018f28.png";